import { Checkbox, Col, Form, Input, Radio, Row, Select } from "antd";
import { AntInput } from "../../../shared/widges/antinput";
import styles from "./scss/creat_form.module.scss";
import { useState } from "react";
import { div } from "@tensorflow/tfjs-core";
const { Option } = Select;



const CustomFormDetails = (props: any) => {
      const [tableData, setCustomFormData, selectedValue, setSelectedValue, customFormData] = props?.tableData;

      const handleInputChange = (event: any) => {
            const { name, value } = event?.target;
            setCustomFormData((prevValues: any) => ({
                  ...prevValues,
                  [name]: value,
            }));
      };

      const handleInputChangeRadio = (e: any, label: any) => {
            const { name, value } = e.target;
            setSelectedValue((prevState: any) => ({
                  ...prevState,
                  [label]: e.target.value,
            }));
            setCustomFormData((prevValues: any) => ({
                  ...prevValues,
                  [label]: value,
            }));
      };

      console.log('tableData::::::::2222564', tableData);


      const renderField = (field: any, index: any) => {
            if (field.columnType === 'Single-line text') {
                  return (
                        <div className={styles.custfrmcontainerhalf}>
                              <label>{field.columnLabel}{field.isMandatory ? <span className="reqStart">*</span> : ''}</label>
                              <Form.Item
                                    key={field.columName}
                                    name={field.columName}
                                    initialValue={customFormData?.[field.columName] ?? null}

                                    rules={[
                                          {
                                                required: (field.isMandatory ? true : false),
                                                message: `${field?.errMsg}` !== '' ? `${field?.errMsg}` : 'Please enter the value',
                                          }
                                    ]}
                              >
                                    <AntInput
                                          className="textBox"
                                          name={field.columName}
                                          placeHolder={field?.placeHolder}
                                          onChange={handleInputChange}
                                    />
                              </Form.Item>
                        </div>
                  );
            }
            if (field.columnType === 'Multi-line text') {
                  return (
                        <div className={styles.custfrmcontainerfull}>
                              <label>{field.columnLabel}{field.isMandatory ? <span className="reqStart">*</span> : ''}</label>
                              <Form.Item
                                    key={field.columName}
                                    name={field.columName}
                                    // className={styles.custfrmcontainerfull}
                                    rules={[
                                          {
                                                required: (field.isMandatory ? true : false),
                                                message: `${field?.errMsg}` !== '' ? `${field?.errMsg}` : 'Please enter the value',
                                          }
                                    ]}
                              >
                                    <Input.TextArea placeholder={field?.placeHolder} name={field.columName}
                                          onChange={handleInputChange}
                                    />
                              </Form.Item>
                        </div>

                  );
            }
            if (field.columnType === "Drop down") {
                  const optionalValues = JSON.parse(field?.columnValue);
                  return (
                        <div className={styles.custfrmcontainerhalf}>
                              <label>{field.columnLabel}{field.isMandatory ?  <span className="reqStart">*</span> : ''}</label>
                              <Form.Item
                                    key={field.columnLabel}
                                    name={field.columName}
                                    // className={styles.custfrmcontainerhalf}
                                    rules={[
                                          {
                                                required: (field.isMandatory ? true : false),
                                                message: `${field?.errMsg}` !== '' ? `${field?.errMsg}` : 'Please enter the value',
                                          }
                                    ]}
                              >
                                    <Select
                                          className="antSelect selectcloseicon"
                                          placeholder={field.placeHolder}
                                          getPopupContainer={(trigger) => trigger.parentNode}
                                          popupClassName="antSelectPopover"
                                          onChange={(value) => handleInputChange({ target: { name: field.columName, value } })}
                                          suffixIcon={<svg xmlns="http://www.w3.org/2000/svg" width="12" height="6" viewBox="0 0 12 6" fill="none">
                                                <path d="M6.00155 5.90231C5.39905 5.90231 4.83355 5.66791 4.40825 5.24121L0.554751 1.37691C0.262251 1.08391 0.263251 0.609307 0.556251 0.316407C0.850151 0.024407 1.32525 0.0244068 1.61725 0.318407L5.47025 4.18271C5.75395 4.46591 6.24955 4.46591 6.53225 4.18271L10.3858 0.318407C10.6778 0.0245068 11.1529 0.024507 11.4468 0.316407C11.7398 0.609407 11.7407 1.08401 11.4483 1.37691L7.59475 5.24121C7.16945 5.66801 6.60365 5.90231 6.00155 5.90231Z" fill="#757676" />
                                          </svg>}
                                    >
                                          {optionalValues.map((option: any) => (
                                                <Option key={option.name} value={option.name}>
                                                      {option.name}
                                                </Option>
                                          ))}
                                    </Select>
                              </Form.Item>
                        </div>
                  );
            }
            if (field.columnType === "Radio Button") {
                  const optionalValues = JSON.parse(field?.columnValue);
                  console.log('field:::::::::', selectedValue, selectedValue[field?.columName])
                  return (
                        <div className={styles.custfrmcontainerfull}>

                              <label>{field?.columnLabel}{field.isMandatory ?  <span className="reqStart">*</span> : ''}</label>
                              <Form.Item
                                    key={field?.columName}
                                    name={field?.columName}
                                    // className={styles.custfrmcontainerfull}
                                    rules={[
                                          {
                                                required: field.isMandatory ? true : false,
                                                message: field?.errMsg !== '' ? field?.errMsg : 'Please enter the value',
                                          },
                                    ]}
                              >
                                    <Radio.Group
                                          onChange={(e) => handleInputChangeRadio(e, field?.columName)}
                                    // value={selectedValue[field?.columName] ?? ''}
                                    >
                                          {optionalValues?.map((option: any) => (
                                                <Radio value={option?.name} key={option?.name}>
                                                      {option?.name}
                                                </Radio>
                                          ))}
                                    </Radio.Group>
                              </Form.Item>
                        </div>

                  );
            }
            if (field.columnType === "Check Box") {
                  const optionalValues = JSON.parse(field?.columnValue);
                  return (
                        <div className={styles.custfrmcontainerfull}>
                              <label>{field.columnLabel}{field.isMandatory ? <span className="reqStart">*</span> : ''}</label>
                              <Form.Item
                                    key={field.columnLabel}
                                    name={field.columName}
                                    valuePropName="checked"
                                    // className={styles.custfrmcontainerfull}
                                    rules={[
                                          {
                                                required: (field.isMandatory ? true : false),
                                                message: `${field?.errMsg}` !== '' ? `${field?.errMsg}` : 'Please enter the value',
                                          }
                                    ]}
                              >
                                    <Checkbox.Group name={field?.columName}
                                          onChange={(value) => {
                                                handleInputChange({ target: { name: field.columName, value } })
                                          }} >
                                          {optionalValues.map((option: any) => (
                                                <Checkbox key={option.name} value={option.name}>
                                                      {option.name}
                                                </Checkbox>
                                          ))}
                                    </Checkbox.Group>
                              </Form.Item>
                        </div>
                  );
            }
            return null;
      };

      return (
            <div className={styles.custfrmcontainer}>
                  {tableData.map((field: any, index: any) => renderField(field, index))}
            </div >
      )
}

export default CustomFormDetails